<section class="login-shell d-flex justify-content-center align-items-center vh-100">
  <div class="login-card p-4 rounded shadow">
    <div class="d-flex justify-content-center mb-3">
      <img class="ff-logo" src="assets/images/svg/fagforbundet-logo-rgb.webp" alt="Logo" />
    </div>
    <div class="text-center">
      <h3 class="login-title">Tilgang til<br />Min Side</h3>
      <p class="login-subtitle custom-spacing fw-normal fs-6 p-3">Din inngangsport til Fagforbundet</p>
      <button class="ms-3 mb-4 w-50 align-items-left p-3 button primary" (click)="loginBankId()" [disabled]="providerLoginInProgress">Logg inn</button>
    </div>
    @if (errorMessage) {
      <div class="auth-error link">
        {{ errorMessage }}
        @if (showContactLink) {
          <a href="https://kontakt.fagforbundet.no/" target="_blank" rel="noopener noreferrer">
            kontakt oss
          </a>
        }
      </div>
    }
  </div>
</section>
